import { PropsWithChildren } from 'react';
import { DimGrunnlagProvider } from './DimGrunnlagProvider.tsx';
import { InputErrorContextProvider } from './InputErrorProvider.tsx';
import { OverbygningContextProvider } from './OverbygningProvider.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import UnleashProvider from './UnleashProvider.tsx';

const ContextProviders = ({ children }: PropsWithChildren) => {
	const queryClient = new QueryClient();
	return (
		<InputErrorContextProvider>
			<OverbygningContextProvider>
				<QueryClientProvider client={queryClient}>
					<UnleashProvider>
						<DimGrunnlagProvider>{children}</DimGrunnlagProvider>
					</UnleashProvider>
				</QueryClientProvider>
			</OverbygningContextProvider>
		</InputErrorContextProvider>
	);
};

export default ContextProviders;
